// Custom cursor functionality
export function initializeCursor(): void {
  const cursor = document.querySelector('.cursor') as HTMLElement;
  const cursorFollower = document.querySelector('.cursor-follower') as HTMLElement;

  if (!cursor || !cursorFollower) return;

  let mouseX = 0;
  let mouseY = 0;
  let followerX = 0;
  let followerY = 0;
  let isInitialized = false;

  // Update mouse position
  const moveCursor = (e: { clientX: number; clientY: number }) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
    followerX = mouseX;
    followerY = mouseY;
    // Initialize follower position to current mouse position on first move
    if (!isInitialized) {
      cursorFollower.classList.add('initialized');
      isInitialized = true;
    }

    // Update cursor position immediately
    cursor.style.transform = `translate3d(${mouseX - 10}px, ${mouseY - 10}px, 0)`;
  };
  document.addEventListener('mousemove', moveCursor);

  // Smooth follower animation
  function moveFollower() {
    followerX += mouseX - followerX; // * 0.6;
    followerY += mouseY - followerY; // * 0.6;

    cursorFollower.style.transform = `translate3d(${followerX - 20}px, ${followerY - 20}px, 0)`;

    requestAnimationFrame(moveFollower);
  }
  moveFollower();

  // Hide cursor when leaving the window
  document.addEventListener('mouseleave', () => {
    cursor.style.opacity = '0';
    cursorFollower.style.opacity = '0';
  });

  document.addEventListener('mouseenter', () => {
    cursor.style.opacity = '1';
    cursorFollower.style.opacity = '1';
  });
}
